//import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import './stylesheet/mdb.custom.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './view/App';

ReactDOM.render(<App />, document.getElementById('root'));
